// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"components-TourTicketLazyLoading-TourTicketLazyLoading__spinnerContainer--2Kfu_","blur":"components-TourTicketLazyLoading-TourTicketLazyLoading__blur--3aZFW"};